// This file maps state to stores, and also exposes a fetchData function to fetch all the
// data needed to render the smart component
import ActionStore from '@src/ActionStore';
import BusinessStore from './store';
import * as BMSelectors from './store/selectors';
import * as BMActions from './store/actions';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [ActionStore, BusinessStore.getStore()];

export const mapActionsToProps = {
  getBusinessData: BMActions.getBusinessData,
  editBusinessData: BMActions.editBusinessData,
  validateBusinessData: BMActions.validateBusinessData,
  clearBusinessDataValidationErrors:
    BMActions.clearBusinessDataValidationErrors,
  saveBusinessData: BMActions.saveBusinessData,

  transferBusiness: BMActions.transferBusiness,
  transferTasks: BMActions.transferTasks,
  transferPromptTriggers: BMActions.transferPromptTriggers,
};

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  const state = BusinessStore.getState();
  const business = BMSelectors.getBusinessData(state);
  return {
    loadStatus: ActionStore.getLoadStatus(),
    alertStatus: ActionStore.getAlertStatus(),
    componentTooltipStatus: ActionStore.getComponentTooltipStatus(),
    confirmationDialogStatus: ActionStore.getConfirmationDialogStatus(),

    allBots: BMSelectors.getAllBots(state),
    allTasks: BMSelectors.getAllTasks(state),
    allPlatforms: BMSelectors.getAllPlatforms(state),
    allErrors: BMSelectors.getAllErrors(state),
    allTeams: BMSelectors.getAllTeams(state),
    allClients: BMSelectors.getAllClients(state),
    allPartners: BMSelectors.getAllPartners(state),
    allLanguages: BMSelectors.getSupportedLanguages(state),
    allLacts: BMSelectors.getAllLacts(state),

    id: BMSelectors.getBusinessId(state),
    reversePartnerIdMap: BMSelectors.getReversePartnerIdMap(state),

    businessDataEdited: BMSelectors.getBusinessDataEditStatus(state),
    generalSettings: business.generalSettings,
    partnerSpecificSettings: business.partnerSpecificSettings,
    botPromptTriggerSettings: business.botPromptTriggerSettings,

    ...mapActionsToProps,
  };
}
